import {
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
} from "@prismicio/editor-ui"
import type { IntegrationFieldContent } from "@prismicio/types-internal/lib/content"
import { IntegrationField as IntegrationFieldT } from "@prismicio/types-internal/lib/customtypes"
import { useState } from "react"

import { getFieldLabel } from "../utils"
import type { IntegrationItem } from "./integrationData"
import { IntegrationDialog } from "./IntegrationDialog"
import { IntegrationInput, IntegrationInputFooter } from "./IntegrationInput"

interface Props {
  id: string
  field: IntegrationFieldT
  content?: IntegrationFieldContent
  onContentChange: (content?: IntegrationFieldContent) => void
  readOnly: boolean
}

export function IntegrationField(props: Props) {
  const { id, field, content, readOnly, onContentChange } = props

  const [open, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<
    IntegrationItem | undefined
  >()

  const catalogId = field.config?.catalog

  if (!catalogId) return null

  function onSelectItem(item: IntegrationItem) {
    onContentChange({
      value: item.id,
      __TYPE__: "IntegrationFieldsContent",
    })
    setSelectedItem(item)
    setOpen(false)
  }

  function onClearItem() {
    onContentChange(undefined)
    setSelectedItem(undefined)
  }

  return (
    <>
      <Field
        footer={
          <IntegrationInputFooter
            catalogId={catalogId}
            item={selectedItem}
            itemId={content?.value}
          />
        }
      >
        <FieldIcon name="multipleStop" />
        <FieldLabel htmlFor={id}>{getFieldLabel(field)}</FieldLabel>
        <FieldControl>
          <IntegrationInput
            id={id}
            field={field}
            readOnly={readOnly}
            catalogId={catalogId}
            item={selectedItem}
            itemId={content?.value}
            onFocus={() => setOpen(true)}
            onClearItem={onClearItem}
          />
        </FieldControl>
      </Field>
      <IntegrationDialog
        open={open}
        onOpenChange={setOpen}
        catalogId={catalogId}
        onSelectItem={onSelectItem}
      />
    </>
  )
}
